import { mapState, mapMutations } from 'vuex'
import TextModal from '@/components/modals/text-modal/text-modal.vue'

export default {
  name: 'ErrorModal',
  components: {
    TextModal
  },
  computed: {
    ...mapState({
      errors: state => state.serverErrors.errors
    })
  },
  methods: {
    ...mapMutations({
      clearErrors: 'serverErrors/CLEAR_ERRORS'
    }),
    show () {
      this.$refs.modal.show()
    },
    hide() {
      this.$refs.modal.hide()
    },
    onHide() {
      this.clearErrors()
    }
  },
  watch: {
    'errors.length'() {
      if (this.errors.length) {
        this.show()
      }
    }
  }
}